import protoRoot from "../proto-root";

function create({ videoQuality }) {
  const ParentStationState = protoRoot.lookupType("comm.ParentStationState");
  const MonitoringModeType = protoRoot.lookupEnum("comm.MonitoringModeType");
  const ParentStationVideoQualitySettings = protoRoot.lookupType(
    "ParentStationVideoQualitySettings"
  );
  const VideoQualityType = protoRoot.lookupEnum("comm.VideoQualityType");
  const NetworkType = protoRoot.lookupEnum("comm.NetworkType");

  return ParentStationState.create({
    monitoringModeType: MonitoringModeType.values["FOREGROUND"],
    videoQualitySettings: ParentStationVideoQualitySettings.create({
      onWifi: VideoQualityType.values[videoQuality]
    }),
    networkType: NetworkType.values["WIFI"]
  });
}

export default {
  create
};

// message ParentStationState {
//   MonitoringModeType monitoringModeType = 10;
//   ParentStationVideoQualitySettings videoQualitySettings = 2;
//   NetworkType networkType = 3;
// }
